import { Drawer, Flex, Modal } from "antd";
import React, { useState, useEffect } from "react";
import AIfilter from "./AIfilter";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { setActiveStep } from "store/slices/searcSlice";
import { createStyles } from "antd-style";
import SearchInitiatorFilter from "components/AISeearchMain/SearchInitiatorFilters";
import FilterModalHeader from "components/Common/modal/FilterModalHeader";
import FiltersSidebar from "./FilterSideBar";
import { filtersSidebarData } from "utils/Data";
import AISearchAndSet from "./AISearchAndSet";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import helpicon from "../../images/helpicon.svg";

interface AIFiltersPopUpProps {
    isFilterQuery?: boolean;
    filterOpen: boolean;
    isModal?: boolean;
    runFrom?: string;
    handleClose: () => void;
}

const useStyle = createStyles(({ token }) => ({
    'my-modal-body': {
        background: token.blue1,
        padding: token.paddingSM,
    },
    'my-modal-mask': {
        boxShadow: `inset 0 0 15px #fff`,
    },
    'my-modal-header': {
        borderBottom: `1px dotted ${token.colorPrimary}`,
    },
    'my-modal-footer': {
        color: token.colorPrimary,
    },
    'my-modal-content': {
        padding: `0 !important`,
        borderRadius: `12px !important`,
    },
}));


const AIFiltersPopUp: React.FC<AIFiltersPopUpProps> = ({ isFilterQuery, filterOpen, handleClose, runFrom, isModal }) => {
    const [isSearching, setIsSearching] = useState(false);
    const [activeTab, setActiveTab] = useState("Filters");
    const [open, setOpen] = useState(false);
    const [key, setKey] = useState(0);
    const isNamedSearch = useAppSelector((state) => state.search.isNamedSearch);

    const { styles } = useStyle();

    const handleSearchLoading = (value: boolean) => {
        setIsSearching(value);
    };

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const classNames = {
        content: styles['my-modal-content'],
    };


    // Change key when modal opens to force re-render
    useEffect(() => {
        if (filterOpen) {
            setKey((prevKey) => prevKey + 1);
        }
    }, [filterOpen]);

    return (
        <Modal
            open={filterOpen}
            onCancel={() => !isSearching && handleClose()}
            style={{ top: 20, padding: 0 }}
            width={950}
            // footer={null}
            wrapClassName="p-0"
            rootClassName="p-0"
            footer={
                <div className="py-3" >
                    {/* <SearchInitiatorFilter setIsSearchLoading={handleSearchLoading} /> */}
                </div>
            }
            classNames={classNames}
        >
            <FilterModalHeader
                setIsSearchLoading={handleSearchLoading}
                showDrawer={toggleDrawer}
                runFrom={runFrom}
                isModal={isModal}
            />
            <div
                style={{
                    maxHeight: "75vh",
                    padding: "24px",
                    paddingTop: 0,
                    // pointerEvents: open ? "none" : "auto",
                }}
                className="relative flex"
            >
                {filterOpen && (
                    <>
                        {!isNamedSearch &&
                            <div className={`transition-all ${open ? "w-[250px]" : "w-0 overflow-hidden"}`}>

                                <FiltersSidebar
                                    activeTab={activeTab}
                                    data={filtersSidebarData}
                                    setActiveTab={setActiveTab}
                                ></FiltersSidebar>
                            </div>}
                        <div className={`${isNamedSearch ? "h-auto" : "h-[75vh]"} w-full overflow-y-auto`}>
                            {isNamedSearch ? null : (
                                <div className="py-6 px-5 xl:px-8 border-b border-dashed border-main-border flex gap-5 xl:gap-12">
                                    <div className="w-1/4">
                                        <SectionTitleAndDescription
                                            title="Boolean Extractor"
                                            isRequiredSection={true}
                                            isHelpInfoReq={false}
                                            description="Define your ideal candidate profile, then construct a boolean search string to match it. Your boolean string can be used to source on other platforms."
                                        />
                                    </div>
                                    <div className="w-3/4">
                                        <AISearchAndSet />
                                    </div>

                                </div>
                            )}
                            <AIfilter
                                key={key}
                                isSearchResult={true}
                                setIsSearchLoading={handleSearchLoading}
                                isFilterQuery={isFilterQuery}
                                runFrom={runFrom}
                                isModal={isModal}
                            />
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default AIFiltersPopUp;
